/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dialog-text-row[_ngcontent-%COMP%]{display:flex;align-items:baseline;padding:4px 0}.dialog-text-label[_ngcontent-%COMP%]{font-weight:600;margin-right:8px;white-space:nowrap}.dialog-text-value[_ngcontent-%COMP%]{word-break:break-word}\n/*# sourceMappingURL=custom-dialog.component.css.map*/"];
export { styles as styles };
